<template>
	<div class="async-loading">
		<div class="async-loading__spinner"></div>
	</div>
</template>

<script setup></script>

<style lang="scss" scoped>
.async-loading {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 60vh;

	&__spinner {
		width: 64rpx;
		height: 64rpx;
		border: 4rpx solid #eee;
		border-top-color: #000;
		border-radius: 50%;
		animation: async-loading-spin 0.8s linear infinite;
	}
}

@keyframes async-loading-spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
